import React, { useState } from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Layout from '../shared/layout';
import GroupsList from './groups-list';
import GroupDetails from './groups-details';
import { Resource } from '../models/group';

interface Props {
  id?: string;
  resource?: Resource;
}

export default function Groups({ ...props }: Props) {
  const [group, setGroup] = useState({
    id: props.id || '',
    resource: props.resource || Resource.Members,
  });

  return (
    <>
      <CssBaseline />
      <Layout>
        <>
          {!group.id
            ? (<GroupsList onClickGroup={(id) => setGroup({ ...group, id })} />)
            : (
              <GroupDetails
                id={group.id}
                resource={group.resource}
                setGroup={setGroup}
              />
            )}
        </>
      </Layout>
    </>
  );
}
